import React from 'react';
import {
  Paper,
  Typography,
  Box,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Divider,
  Chip
} from '@mui/material';
import { extractName, standardInputSx } from '../utils/hubsHelpers';

const PlacementCard = ({
  pHome,
  setPHome,
  pTab,
  setPTab,
  pOrder,
  setPOrder,
  isCategoryWise,
  setIsCategoryWise,
  isLocationWise,
  setIsLocationWise,
  isDateWise,
  setIsDateWise,
  relatedGroups,
  town,
  state,
  subCategory,
  category,
  removeRelHub,
  openDrawer
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: '#FFFFFF',
        border: '1px solid #E2E8F0',
        borderRadius: '8px',
        p: '14px 16px',
        mb: 1.75,
        boxShadow: 'none'
      }}
    >
      <Typography variant="subtitle1" sx={{ fontSize: 13.5, fontWeight: 600, color: '#1E293B', mb: 0.35, display: 'flex', alignItems: 'center' }}>
        Placement{' '}
        <Box component="span" sx={{ backgroundColor: '#803927', color: '#fff', fontSize: 9.5, px: '5px', py: '1px', borderRadius: '4px', fontWeight: 600, ml: 0.75 }}>
          NEW
        </Box>
      </Typography>
      <Typography variant="body2" sx={{ color: '#64748B', fontSize: 11, mb: 1.25 }}>
        Where this page is linked from once it is live.
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 0.75 }}>
        <Checkbox
          checked={pHome}
          onChange={(e) => setPHome(e.target.checked)}
          size="small"
          sx={{ p: 0, color: '#803927', '&.Mui-checked': { color: '#803927' } }}
        />
        <Typography sx={{ fontSize: 12.5, color: '#1E293B' }}>
          Show on homepage, Popular Retreat Destinations
        </Typography>
      </Box>

      {pHome && (
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', my: 1, pl: 3 }}>
          <FormControl size="small" sx={{ flex: 1, ...standardInputSx }}>
            <InputLabel id="placement-tab-label">Tab</InputLabel>
            <Select
              labelId="placement-tab-label"
              value={pTab}
              label="Tab"
              onChange={(e) => setPTab(e.target.value)}
              sx={{ height: 34, fontSize: 12 }}
            >
              <MenuItem value="">
                <em>Select Tab</em>
              </MenuItem>
              <MenuItem value="Retreat">Retreat</MenuItem>
              <MenuItem value="Trainings">Trainings</MenuItem>
              <MenuItem value="Other Retreats & Trainings">Other Retreats & Trainings</MenuItem>
            </Select>
          </FormControl>

          <TextField
            size="small"
            label="Order"
            type="number"
            placeholder="e.g. 1"
            value={pOrder}
            onChange={(e) => setPOrder(e.target.value === '' ? '' : Number(e.target.value))}
            inputProps={{ min: 1 }}
            sx={{ width: 80, ...standardInputSx, '& .MuiOutlinedInput-root': { ...standardInputSx['& .MuiOutlinedInput-root'], height: 34 } }}
          />
        </Box>
      )}

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 0.75, opacity: 0.85 }}>
        <Checkbox checked disabled size="small" sx={{ p: 0, color: '#803927', '&.Mui-checked': { color: '#803927' } }} />
        <Typography sx={{ fontSize: 12.5, color: '#1E293B' }}>
          Footer hub: Categories <span style={{ color: '#64748B', fontSize: 11 }}>(automatic when live)</span>
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 0.75, opacity: 0.85 }}>
        <Checkbox checked disabled size="small" sx={{ p: 0, color: '#803927', '&.Mui-checked': { color: '#803927' } }} />
        <Typography sx={{ fontSize: 12.5, color: '#1E293B' }}>
          Footer hub: Locations <span style={{ color: '#64748B', fontSize: 11 }}>(automatic when live)</span>
        </Typography>
      </Box>

      <Divider sx={{ my: 1.25, borderColor: '#F1F5F9' }} />
      <Typography sx={{ fontSize: 11.5, fontWeight: 600, color: '#475569', mb: 1, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
        Hub Classification
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 0.75 }}>
        <Checkbox
          checked={isCategoryWise}
          onChange={(e) => setIsCategoryWise(e.target.checked)}
          size="small"
          sx={{ p: 0, color: '#803927', '&.Mui-checked': { color: '#803927' } }}
        />
        <Typography sx={{ fontSize: 12.5, color: '#1E293B' }}>
          Category Wise Hub
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 0.75 }}>
        <Checkbox
          checked={isLocationWise}
          onChange={(e) => setIsLocationWise(e.target.checked)}
          size="small"
          sx={{ p: 0, color: '#803927', '&.Mui-checked': { color: '#803927' } }}
        />
        <Typography sx={{ fontSize: 12.5, color: '#1E293B' }}>
          Location Wise Hub
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 0.75 }}>
        <Checkbox
          checked={isDateWise}
          onChange={(e) => setIsDateWise(e.target.checked)}
          size="small"
          sx={{ p: 0, color: '#803927', '&.Mui-checked': { color: '#803927' } }}
        />
        <Typography sx={{ fontSize: 12.5, color: '#1E293B' }}>
          Date / Season Wise Hub
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 0.75, opacity: 0.85 }}>
        <Checkbox disabled size="small" sx={{ p: 0 }} />
        <Typography sx={{ fontSize: 12.5, color: '#1E293B' }}>
          Footer hub: Dates <span style={{ color: '#64748B', fontSize: 11 }}>(only when a month is set)</span>
        </Typography>
      </Box>

      <Divider sx={{ my: 1.25, borderColor: '#F1F5F9' }} />


    </Paper>
  );
};

export default React.memo(PlacementCard);
